import { render, staticRenderFns } from "./televisionShow.vue?vue&type=template&id=51678b5c&scoped=true"
import script from "./televisionShow.vue?vue&type=script&lang=js"
export * from "./televisionShow.vue?vue&type=script&lang=js"
import style0 from "./televisionShow.vue?vue&type=style&index=0&id=51678b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51678b5c",
  null
  
)

export default component.exports